(() => {
    const DEBUG = false;
    const log = (...a) => DEBUG && console.log('[A11Y]', ...a);

    // пометки «уже чинили»
    const fixedSets = {
        searchBtn: new WeakSet(),
        pagination: new WeakSet(),
        sortToggle: new WeakSet(),
        categoryListBtn: new WeakSet(),
        nextPrev: new WeakSet(),
    };

    // утилиты (аккуратные)
    const setAttr = (el, name, val) => {
        if (!el) return;
        if (el.getAttribute(name) !== val) el.setAttribute(name, val);
    };
    const delAttr = (el, name) => {
        if (!el) return;
        if (el.hasAttribute(name)) el.removeAttribute(name);
    };

    // ==== фиксы (без разрушения DOM) ====

    function fixSearchButton(root = document) {
        root.querySelectorAll('.gf-controls-search-button').forEach(btn => {
            if (fixedSets.searchBtn.has(btn)) return;
            setAttr(btn, 'aria-label', 'Search');
            fixedSets.searchBtn.add(btn);
            log('Fix Search Button');
        }); //ok
    }

    function fixPagination(root = document) {
        const el = root.querySelector('#gf_pagination_wrap');
        if (!el || fixedSets.pagination.has(el)) return;

        // вместо замены тега → добавим семантику/класс
        // setAttr(el, 'role', 'navigation');
        el.classList.add('a11y-pagination');
        fixedSets.pagination.add(el);
        log('Fix Pagination semantics'); // need check result in plugin a18y
    }

    function fixTopSellerDropdown(root = document) {
        root.querySelectorAll('.sort-by-toggle').forEach(label => {
            if (fixedSets.sortToggle.has(label)) return;
            delAttr(label, 'aria-expanded');
            delAttr(label, 'role'); // не нужен на label/кнопке
            fixedSets.sortToggle.add(label);
            log('Fix Top Seller Dropdown');
        }); //ok
    }

    function fixCategoryList(root = document) {
        root.querySelectorAll('button[type="button"][role="link"]').forEach(btn => {
            if (fixedSets.categoryListBtn.has(btn)) return;
            delAttr(btn, 'aria-checked'); // у «link» неуместно
            fixedSets.categoryListBtn.add(btn);
        });
        log('Fix Category List'); // ok
    }

    function fixPaginationArrow(root = document) {
        const scope = root.querySelector('#gf_pagination_wrap') || root;
        scope.querySelectorAll('a[rel="next"], a[rel="prev"]').forEach(a => {
            if (fixedSets.nextPrev.has(a)) return;

            if (a.rel === 'next') setAttr(a, 'aria-label', 'Next page');
            if (a.rel === 'prev') setAttr(a, 'aria-label', 'Previous page');

            // не навешиваем инлайновые стили — лучше классом
            a.classList.add('a11y-visible-link');

            fixedSets.nextPrev.add(a);
        });
        log('Fix pagination arrows');
    }

    function wrapPaginationContentDivOnce(root = document){
        const ul = root.getElementById('gf_pagination_wrap');
        if (!ul || ul.dataset.a11yLiWrapped) return;
        const div = ul.querySelector(':scope > div#pagination');
        if (!div) return;
        const li = root.createElement('li');
        li.className = 'pagination__container';
        ul.replaceChild(li, div);
        li.appendChild(div);
        ul.dataset.a11yLiWrapped = '1';
    }

    // один общий «прогон»
    function runAll(root = document) {
        fixSearchButton(root);
        // fixPagination(root);
        wrapPaginationContentDivOnce(root)
        fixTopSellerDropdown(root);
        fixCategoryList(root);
        fixPaginationArrow(root);
    }

    // первый прогон после idle (не блокируем FCP)
    const start = () => {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => runAll(document), { timeout: 1000 });
        } else {
            setTimeout(() => runAll(document), 0);
        }
    };

    // один глобальный observer + дебаунс
    let debTimer = null;
    const observer = new MutationObserver((mutList) => {
        // игнорируем мутации, где нет элементов (например, только атрибуты текста)
        const hasMeaningful =
            mutList.some(m => m.type === 'childList' && (m.addedNodes && m.addedNodes.length));
        if (!hasMeaningful) return;

        clearTimeout(debTimer);
        debTimer = setTimeout(() => {
            // батчим обработки — и запускаем фиксы на ближайшем общем предке
            // (или просто на document — дешевле и надёжнее)
            runAll(document);
        }, 250);
    });

    // наблюдаем один раз, отключаем по unload
    const observe = () => {
        observer.observe(document.body, { childList: true, subtree: true });
        window.addEventListener('beforeunload', () => observer.disconnect(), { once: true });
    };

    // стили для «видимости» стрелок вместо инлайна
    (function injectOnceCSS(){
        const id = 'a11y-fixes-styles';
        if (document.getElementById(id)) return;
        const css = `
      .a11y-visible-link { color: inherit; opacity: 1; }
      #gf_pagination_wrap.a11y-pagination { /* при желании — доп.оформление */ }
    `;
        const style = document.createElement('style');
        style.id = id;
        style.textContent = css;
        document.head.appendChild(style);
    })();

    log('Runner started');
    start();
    observe();
})();